/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Infra API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  GetV7InfraContainersInfoByContainerIdParams,
  GetV7InfraContainersLogByContainerIdParams,
  InfraContainerInfoV7Response,
  InfraContainerRelationV7Response,
  LogResponse,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary 호스트  컨테이너 정보
 */
export const getV7InfraContainersInfoByContainerId = (
  containerId: MaybeRef<string>,
  params?: MaybeRef<GetV7InfraContainersInfoByContainerIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  containerId = unref(containerId);
  params = unref(params);

  return customAxiosInstance<InfraContainerInfoV7Response>(
    {
      url: `/api/v7/infra/containers/${containerId}/info`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7InfraContainersInfoByContainerIdQueryKey = (
  containerId?: MaybeRef<string>,
  params?: MaybeRef<GetV7InfraContainersInfoByContainerIdParams>,
) => {
  return [
    'api',
    'v7',
    'infra',
    'containers',
    containerId,
    'info',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7InfraContainersInfoByContainerIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7InfraContainersInfoByContainerId>>,
  TError = ErrorType<unknown>,
>(
  containerId: MaybeRef<string>,
  params?: MaybeRef<GetV7InfraContainersInfoByContainerIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7InfraContainersInfoByContainerId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7InfraContainersInfoByContainerIdQueryKey(containerId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7InfraContainersInfoByContainerId>>
  > = ({ signal }) =>
    getV7InfraContainersInfoByContainerId(containerId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(containerId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7InfraContainersInfoByContainerId>>,
    TError,
    TData
  >;
};

export type GetV7InfraContainersInfoByContainerIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7InfraContainersInfoByContainerId>>
>;
export type GetV7InfraContainersInfoByContainerIdQueryError = ErrorType<unknown>;

/**
 * @summary 호스트  컨테이너 정보
 */

export function useGetV7InfraContainersInfoByContainerId<
  TData = Awaited<ReturnType<typeof getV7InfraContainersInfoByContainerId>>,
  TError = ErrorType<unknown>,
>(
  containerId: MaybeRef<string>,
  params?: MaybeRef<GetV7InfraContainersInfoByContainerIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7InfraContainersInfoByContainerId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7InfraContainersInfoByContainerIdQueryOptions(
    containerId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary getContainerLog
 */
export const getV7InfraContainersLogByContainerId = (
  containerId: MaybeRef<string>,
  params?: MaybeRef<GetV7InfraContainersLogByContainerIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  containerId = unref(containerId);
  params = unref(params);

  return customAxiosInstance<LogResponse>(
    {
      url: `/api/v7/infra/containers/${containerId}/log`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV7InfraContainersLogByContainerIdQueryKey = (
  containerId?: MaybeRef<string>,
  params?: MaybeRef<GetV7InfraContainersLogByContainerIdParams>,
) => {
  return [
    'api',
    'v7',
    'infra',
    'containers',
    containerId,
    'log',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV7InfraContainersLogByContainerIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7InfraContainersLogByContainerId>>,
  TError = ErrorType<unknown>,
>(
  containerId: MaybeRef<string>,
  params?: MaybeRef<GetV7InfraContainersLogByContainerIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7InfraContainersLogByContainerId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7InfraContainersLogByContainerIdQueryKey(containerId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7InfraContainersLogByContainerId>>
  > = ({ signal }) =>
    getV7InfraContainersLogByContainerId(containerId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(containerId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7InfraContainersLogByContainerId>>,
    TError,
    TData
  >;
};

export type GetV7InfraContainersLogByContainerIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7InfraContainersLogByContainerId>>
>;
export type GetV7InfraContainersLogByContainerIdQueryError = ErrorType<unknown>;

/**
 * @summary getContainerLog
 */

export function useGetV7InfraContainersLogByContainerId<
  TData = Awaited<ReturnType<typeof getV7InfraContainersLogByContainerId>>,
  TError = ErrorType<unknown>,
>(
  containerId: MaybeRef<string>,
  params?: MaybeRef<GetV7InfraContainersLogByContainerIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7InfraContainersLogByContainerId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7InfraContainersLogByContainerIdQueryOptions(
    containerId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 호스트  컨테이너 관계 정보 - Application 한정 개발
 */
export const getV7InfraContainersRelationInfoByContainerId = (
  containerId: MaybeRef<string>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  containerId = unref(containerId);

  return customAxiosInstance<InfraContainerRelationV7Response>(
    { url: `/api/v7/infra/containers/${containerId}/relation-info`, method: 'GET', signal },
    options,
  );
};

export const getGetV7InfraContainersRelationInfoByContainerIdQueryKey = (
  containerId?: MaybeRef<string>,
) => {
  return ['api', 'v7', 'infra', 'containers', containerId, 'relation-info'] as const;
};

export const getGetV7InfraContainersRelationInfoByContainerIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7InfraContainersRelationInfoByContainerId>>,
  TError = ErrorType<unknown>,
>(
  containerId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7InfraContainersRelationInfoByContainerId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7InfraContainersRelationInfoByContainerIdQueryKey(containerId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV7InfraContainersRelationInfoByContainerId>>
  > = ({ signal }) =>
    getV7InfraContainersRelationInfoByContainerId(containerId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(containerId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7InfraContainersRelationInfoByContainerId>>,
    TError,
    TData
  >;
};

export type GetV7InfraContainersRelationInfoByContainerIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV7InfraContainersRelationInfoByContainerId>>
>;
export type GetV7InfraContainersRelationInfoByContainerIdQueryError = ErrorType<unknown>;

/**
 * @summary 호스트  컨테이너 관계 정보 - Application 한정 개발
 */

export function useGetV7InfraContainersRelationInfoByContainerId<
  TData = Awaited<ReturnType<typeof getV7InfraContainersRelationInfoByContainerId>>,
  TError = ErrorType<unknown>,
>(
  containerId: MaybeRef<string>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV7InfraContainersRelationInfoByContainerId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7InfraContainersRelationInfoByContainerIdQueryOptions(
    containerId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
